// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CapabilitySetRequest
 */
export interface CapabilitySetRequest {
    /**
     * 
     * @type {string}
     * @memberof CapabilitySetRequest
     */
    audience: CapabilitySetRequestAudienceEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CapabilitySetRequest
     */
    capabilities: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySetRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySetRequest
     */
    display_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CapabilitySetRequest
     */
    groups: Array<string>;
    /**
     * snake_case id. Required on create; on edit it must match the path or be omitted.
     * @type {string}
     * @memberof CapabilitySetRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySetRequest
     */
    scope: CapabilitySetRequestScopeEnum;
}


/**
 * @export
 */
export const CapabilitySetRequestAudienceEnum = {
    Internal: 'internal',
    External: 'external'
} as const;
export type CapabilitySetRequestAudienceEnum = typeof CapabilitySetRequestAudienceEnum[keyof typeof CapabilitySetRequestAudienceEnum];

/**
 * @export
 */
export const CapabilitySetRequestScopeEnum = {
    Resource: 'resource',
    Tenant: 'tenant'
} as const;
export type CapabilitySetRequestScopeEnum = typeof CapabilitySetRequestScopeEnum[keyof typeof CapabilitySetRequestScopeEnum];


/**
 * Check if a given object implements the CapabilitySetRequest interface.
 */
export function instanceOfCapabilitySetRequest(value: object): value is CapabilitySetRequest {
    if (!('audience' in value) || value['audience'] === undefined) return false;
    if (!('capabilities' in value) || value['capabilities'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    return true;
}

export function CapabilitySetRequestFromJSON(json: any): CapabilitySetRequest {
    return CapabilitySetRequestFromJSONTyped(json, false);
}

export function CapabilitySetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapabilitySetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'audience': json['audience'],
        'capabilities': json['capabilities'],
        'description': json['description'],
        'display_name': json['display_name'],
        'groups': json['groups'],
        'name': json['name'] == null ? undefined : json['name'],
        'scope': json['scope'],
    };
}

export function CapabilitySetRequestToJSON(json: any): CapabilitySetRequest {
    return CapabilitySetRequestToJSONTyped(json, false);
}

export function CapabilitySetRequestToJSONTyped(value?: CapabilitySetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'audience': value['audience'],
        'capabilities': value['capabilities'],
        'description': value['description'],
        'display_name': value['display_name'],
        'groups': value['groups'],
        'name': value['name'],
        'scope': value['scope'],
    };
}
